import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .main-div {
    background: radial-gradient(
      ellipse farthest-corner at 50% 100%,
      ${colors.background.normal} 20%,
      ${colors.background.dark} 90%
    );
  }

  .pdvend-logo {
    margin-bottom: 20px;
  }

  .login__inner {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }

  .password-recovery {
    font-size: 0.85em;
  }

  .password-recovery-dialog {
    text-align: right;
    margin-top: 16px;
  }

  .divider-style {
    margin-top: 4px;
  }

  .signup-style {
    padding: 12px;
    background-color: #eee;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/login/style.js